import { useEffect } from "react";
import { mustGetElementById } from "./helpers";
import { useProxyErrors } from "./useProxyErrors";
import { useProxyAction } from "./useProxyAction";

const getOptionPhone = () => mustGetElementById('extension_mfaByPhoneOrEmail_phone');
const getOptionEmail = () => mustGetElementById('extension_mfaByPhoneOrEmail_email');
const getOptionNone = () => mustGetElementById('extension_mfaByPhoneOrEmail_none');

const getContinueButton = () => mustGetElementById('continue');
const getCancelButton = () => mustGetElementById('cancel');

const getPageLevelErrors = () => Array.from<HTMLElement>(document.querySelectorAll('#api .pageLevel.error'));

export function useMfaSetupProxy({ mfaOption }: { mfaOption: 'email' | 'phone' | 'none' }) {
  useEffect(() => {
    switch (mfaOption) {
      case 'email':
        getOptionEmail().click();
        break;
      case 'phone':
        getOptionPhone().click();
        break;
      case 'none':
        getOptionNone().click();
        break;
    }
  }, [mfaOption]);

  const continueAction = useProxyAction(getContinueButton);
  const cancelAction = useProxyAction(getCancelButton);

  const error = useProxyErrors(getPageLevelErrors);

  return { continueAction, cancelAction, error };
}
